import React, { forwardRef } from 'react';

import MUITableHead, {
  TableHeadProps as MUITableHeadProps,
} from '@material-ui/core/TableHead';

export interface TableHeadProps extends MUITableHeadProps {}

const TableHead = forwardRef<HTMLTableSectionElement, TableHeadProps>(
  (props, ref) => {
    return <MUITableHead {...props} ref={ref} />;
  }
);

export default TableHead;
